import React from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGavel,
  faHome,
  faTruck,
  faPeopleLine,
  faBriefcase,  
  faScroll,
  faFileAlt,
  faLandmark,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";
const Hizmetler = () => {
  return (
    <>
      <div className="avocatura">
      <Helmet>
  {/* SEO Başlık */}
  <title>Hukuk Hizmetleri | Avukat Ankara | Ali Arda Gül Hukuk Bürosu</title>

  {/* SEO Açıklaması */}
  <meta
    name="description"
    content="Sivil hukuk, ceza hukuku, icra hukuku, aile hukuku, iş hukuku, ticaret hukuku ve şirketler hukuku gibi birçok alanda uzmanlaşmış hukuki danışmanlık ve destek hizmetleri sunuyoruz."
  />

  {/* Anahtar Kelimeler */}
  <meta
    name="keywords"
    content="avukat, Ankara, hukuki hizmetler, aile hukuku, ticaret hukuku, ceza hukuku, Ali Arda Gül"
  />

  {/* Yazar Adı */}
  <meta name="author" content="Ali Arda Gül" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://aliardagul.av.tr/hukuk-hizmetleri" />

  {/* Open Graph Etiketleri */}
  <meta
    property="og:title"
    content="Hukuk Hizmetleri | Avukat Ankara | Ali Arda Gül Hukuk Bürosu"
  />
  <meta
    property="og:description"
    content="Sivil hukuk, ceza hukuku, icra hukuku, aile hukuku, iş hukuku, ticaret hukuku ve şirketler hukuku gibi birçok alanda uzmanlaşmış hukuki danışmanlık ve destek hizmetleri sunuyoruz."
  />
  <meta property="og:image" content="https://aliardagul.av.tr/assets/logo.webp" />
  <meta property="og:url" content="https://aliardagul.av.tr/hukuk-hizmetleri" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Etiketleri */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Hukuk Hizmetleri | Avukat Ankara | Ali Arda Gül Hukuk Bürosu"
  />
  <meta
    name="twitter:description"
    content="Sivil hukuk, ceza hukuku, icra hukuku, aile hukuku, iş hukuku, ticaret hukuku ve şirketler hukuku gibi birçok alanda uzmanlaşmış hukuki danışmanlık ve destek hizmetleri sunuyoruz."
  />
  <meta name="twitter:image" content="https://aliardagul.av.tr/assets/logo.webp" />
</Helmet>

        <div>
          <h6 className="guide-text ms-3 mt-4">HUKUK HİZMETLERİ</h6>
          <div className=" pt-4 text-center">
            <h5 className="fw-bold text-center pb-1">
              Çalışma Alanlarımız
            </h5>
            <h6 className="fw-bold subtitle lh-lg text-center px-5 pb-4">
            Farklı hukuk alanlarında avukatlık ve hukuki danışmanlık hizmeti sunuyoruz.
            </h6>
          </div>
          <div className="row g-5 px-5 pt-4 ">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100 ">
                <div className="civil card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faHome}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">GAYRİMENKUL VE KİRA HUKUKU</h6>
                  <p className="card-text mx-1">
                  Taşınmazların alım-satımı, devri, ipotek, intifa hakkı, kiraya verilmesi, kiralanması gibi konularda ortaya çıkan hukuki uyuşmazlıkların giderilmesi hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="criminal card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faGavel}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">CEZA HUKUKU</h6>
                  <p className="card-text mx-1">
                    Soruşturma makamları ve mahkemeler nezdinde hukuki temsil, dilekçe ve itirazların hazırlanması, ceza hukuku davalarında temsil hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="executare card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faTruck}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">İCRA HUKUKU</h6>
                  <p className="card-text mx-1">
                    İcra davalarında borçlu veya alacaklı olarak sahip olduğunuz hakları koruma ve hukuki temsil sağlama hizmetleri sunuyoruz. İcra hukuku alanındaki pasiflik, hem alacaklı hem de borçlu açısından ciddi sonuçlar doğurabilir.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="family card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faPeopleLine}
                    size="2x"
                    className="pb-3 law-icon"
                  />
                  <h6 className="card-title pb-2">
                    AİLE HUKUKU - BOŞANMA VE MAL PAYLAŞIMI
                  </h6>
                  <p className="card-text mx-1">
                    Boşanma, mal paylaşımı, velayet, nafaka, çocukla görüşme gibi konularda hukuki danışmanlık, destek ve temsil hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="labor card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faBriefcase}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">İŞ HUKUKU</h6>
                  <p className="card-text mx-1">
                  İşten çıkarma, disiplin cezalarına itiraz, işverenin haklarının korunması, maaş ve tazminat haklarının talep edilmesi gibi konularda hukuki destek ve temsil hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="business card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faScroll}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">
                    TİCARET VE ŞİRKETLER HUKUKU
                  </h6>
                  <p className="card-text mx-1">
                    Ticaret sicil işlemleri, şirket kurulumu, adres değişikliği, iş yeri açılışı veya kapatılması, tüzük hazırlama gibi ticaret ve şirketler hukukuna dair hukuki destek ve temsil hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>

                    {/*  Ek  */}

            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="inheritance card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faFileAlt}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">
                  MİRAS HUKUKU
                  </h6>
                  <p className="card-text mx-1">
                  Veraset ilamı başvuruları, miras paylaşımı, mirasın gerçek veya hükmen reddi davalarında avukatlık hizmeti sunuyoruz.
                  </p>
                </div>
              </div>
            </div>


            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="administration card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faLandmark}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">
                  İDARE VE VERGİ HUKUKU
                  </h6>
                  <p className="card-text mx-1">
                  İdarenin hukuka aykırı işlem veya kararlarına karşı açılacak iptal davaları (disiplin cezalarının iptali, yapılar hakkında yıkım kararlarının iptali, vergi cezalarının iptali vb.), yürütmenin durdurulması başvuruları gibi alanlarda avukatlık hizmeti sunuyoruz.
                  </p>
                </div>
              </div>
            </div>




            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="card h-100">
                <div className="health card-img-top">
                  <div className="overlay"></div>
                </div>
                <div className="card-body text-center text-white py-4">
                  <FontAwesomeIcon
                    icon={faStethoscope}
                    size="2x"
                    className="law-icon pb-3"
                  />
                  <h6 className="card-title pb-2">
                  SAĞLIK HUKUKU
                  </h6>
                  <p className="card-text mx-1">
                  Hasta ve hekim arasında çıkabilecek sorunları engelleme, meydana gelen sorunlarda kişileri yasal olarak koruma ve genel itibari ile hasta ve hekim arasındaki ilişkiyi koruma amacıyla avukatlık hizmetleri sunuyoruz.
                  </p>
                </div>
              </div>
            </div>



          </div>



          <hr></hr>
          <div className="container py-4 ">
            <p className="more-services py-4">
            Ayrıca diğer hizmetlerimiz arasında her türlü sözleşmenin hazırlanması, alacak talepli davalar, sosyal güvenlik ve emeklilik hakları, trafik cezalarına itirazlar, araç değer kaybı başvuruları ve araç mahrumiyet tazminatı, devre mülk iptali davaları, her türlü dava ve cevap dilekçelerinin hazırlanması gibi hizmetler de yer almaktadır.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Hizmetler;
